export default interface ISaleData {
    chronologyNumber: string | null;
    saleDate: string | null;
    recordedDate: string | null;
    price: number | null;
    grantee: string | null;
    grantor: string | null;
    documentType: string | null;
    documentNumber: string | null;
    documentBook: string | null;
    documentPage: string | null;
    primaryCategoryCode: string | null;
    armsLength?: boolean;
    isDisabled?: boolean;
    isSelected?: boolean;
}

export function newSaleData(): ISaleData {
    const saleData: ISaleData = {
        chronologyNumber: null,
        saleDate: null,
        recordedDate: null,
        price: null,
        grantee: null,
        grantor: null,
        documentType: null,
        documentNumber: null,
        documentBook: null,
        documentPage: null,
        primaryCategoryCode: null
    };
    return saleData;
}
